"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var introduction;
        (function (introduction) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.createNewDSUrl = appn.emptyString;
                        this.dataSourceRows = appn.emptyString;
                        this.saveConsentUrl = appn.emptyString;
                        this.generateFormUrl = appn.emptyString;
                        this.dataFeedUrl = appn.emptyString;
                    }
                }
                let _initArgs;
                let currentStep = 1;
                let _introLocalStorageKey = '';
                function init(args) {
                    _initArgs = args;
                    _introLocalStorageKey = `productIntroState-${appn.requestProvider.id}`;
                    $('body').addClass('intro-open');
                    addEvents();
                    if (appn.requestUser.allowUsageAnalytics === null || appn.requestUser.allowUsageAnalytics === undefined) {
                        if (appn.requestUser.id !== 0)
                            $('#usage-analytics-modal').css('display', 'flex').show();
                    }
                    const introState = appn.localStorage.getItem(_introLocalStorageKey) || {};
                    if (!introState.hasSeenAccountCreated)
                        appn.posthog.capture('signup', { introVersion: 'v2' });
                    setupAIGeneratorUI();
                    setupAppDownloadUI();
                    checkFirstVisitState();
                    findCurrentStep();
                }
                index.init = init;
                function addEvents() {
                    $('.btn-product-intro-next').on('click', function (e) {
                        e.preventDefault();
                        if (hasGeneratedForm() && currentStep === 2) {
                            const introState = appn.localStorage.getItem(_introLocalStorageKey) || {};
                            introState.currentStep = 3;
                            appn.localStorage.setItem(_introLocalStorageKey, introState);
                            appn.location.navTo(_initArgs.dataFeedUrl, [
                                { name: 'isTour', value: true }
                            ], appn.emptyString, false);
                        }
                        else if (currentStep === 1) {
                            navigateToStep(hasGeneratedForm() ? 2 : 3);
                        }
                    });
                    $('.btn-product-intro-back').on('click', function (e) {
                        e.preventDefault();
                        if (currentStep === 3)
                            navigateToStep(hasGeneratedForm() ? 2 : 1);
                        else
                            navigateToStep(1);
                    });
                    $('.btn-product-intro-skip,.btn-product-intro-complete').on('click', function (e) {
                        const introState = appn.localStorage.getItem(_introLocalStorageKey) || {};
                        const hasSeenFlag = introState.hasSeenAccountCreated;
                        appn.localStorage.setItem(_introLocalStorageKey, {
                            currentStep: 1,
                            hasSeenAccountCreated: hasSeenFlag
                        });
                        appn.localStorage.removeItem('lastGeneratedFormId');
                        appn.localStorage.removeItem('lastGeneratedPrompt');
                        updateStep1NextButton();
                    });
                    $('.btn-product-intro-skip').hover(function () {
                        $('.skip-message').toggleClass('show');
                    });
                    $('.create-ds').on('click', function (e) {
                        e.preventDefault();
                        const data = { name: T('My First Data Source'), items: [] };
                        $.ajax({
                            url: _initArgs.createNewDSUrl,
                            type: 'POST',
                            contentType: 'application/json, charset=utf-8',
                            data: JSON.stringify(data),
                            success: function (result) {
                                appn.location.navTo(_initArgs.dataSourceRows, [
                                    { name: 'id', value: result.Id },
                                    { name: 'isShowImport', value: true }
                                ], appn.emptyString, true);
                            },
                            error: function () { }
                        });
                    });
                    $('#btn-usage-analytics-accept, #btn-usage-analytics-decline').on('click', function (e) {
                        e.preventDefault();
                        const isAllowed = $(this).attr('id') === 'btn-usage-analytics-accept';
                        saveUsageAnalyticsConsent(isAllowed);
                    });
                }
                function navigateToStep(targetStep) {
                    appn.posthog.capture('introduction_viewed', { introStep: targetStep, introVersion: 'v2' });
                    $('.intro-step').attr('style', 'display: none;');
                    $(`.intro-step[data-step="${targetStep}"]`).removeAttr('style');
                    currentStep = targetStep;
                    const introState = appn.localStorage.getItem(_introLocalStorageKey) || {};
                    introState.currentStep = targetStep;
                    appn.localStorage.setItem(_introLocalStorageKey, introState);
                    if (targetStep === 1)
                        updateStep1NextButton();
                }
                function hasGeneratedForm() {
                    return appn.utils.hasValue(appn.localStorage.getItem('lastGeneratedFormId'));
                }
                function updateStep1NextButton() {
                    const text = hasGeneratedForm() ? T(`Next: Your Form is Built`) : T(`Next: Explore`);
                    $('.intro-step[data-step="1"] .btn-product-intro-next').text(text);
                }
                function normalizeStep(value) {
                    if (value === 'explore' || value === 3)
                        return 3;
                    if (value === 1 || value === 2)
                        return value;
                    return 1;
                }
                function setupAppDownloadUI() {
                    const deviceType = appn.getPlatform();
                    const $heroContainer = $('#primary-download-btn');
                    const $targetLinks = $(`#all-download-btns a[data-device="${deviceType}"]`);
                    if ($targetLinks.length > 0) {
                        const $heroLinks = $targetLinks.clone();
                        $heroLinks.find('img').css('max-height', '45px');
                        $heroContainer.empty().append($heroLinks);
                        $targetLinks.hide();
                    }
                }
                function setupAIGeneratorUI() {
                    const $chips = $('.ai-chip');
                    const $textArea = $('#ai-prompt-text');
                    const savedId = appn.localStorage.getItem('lastGeneratedFormId');
                    const savedPrompt = appn.localStorage.getItem('lastGeneratedPrompt');
                    if (appn.utils.hasValue(savedId)) {
                        $textArea.val(savedPrompt || "");
                        const formName = appn.localStorage.getItem('lastGeneratedFormName') || 'form';
                        $('.generated-form-name').text(formName);
                    }
                    else {
                        const initialPrompt = $chips.filter('.active').data('prompt');
                        if (initialPrompt)
                            $textArea.val(initialPrompt);
                    }
                    updateStep1NextButton();
                    $chips.on('click', function (e) {
                        e.preventDefault();
                        $chips.removeClass('active');
                        $(this).addClass('active');
                        const newPrompt = $(this).data('prompt');
                        $textArea.val(newPrompt);
                    });
                    $('#btn-generate-ai-form').on('click', function (e) {
                        e.preventDefault();
                        startAIGenerationSequence();
                    });
                    initAttachmentHandlers();
                    appn.infer.setupAutoInputGrow($textArea);
                    appn.infer.hookSpeechToText($('.prompt-speech'), $('#ai-prompt-text'));
                }
                function initAttachmentHandlers() {
                    const $fileInput = $('#prompt-attachment-input');
                    const $attachBtn = $('.prompt-attachment');
                    const $icon = $attachBtn.find('.prompt-attachment-icon');
                    const $details = $attachBtn.find('.prompt-attachment-details');
                    const $nameSpan = $attachBtn.find('.prompt-attachment-name');
                    const $removeBtn = $attachBtn.find('.prompt-attachment-remove');
                    function resetAttachment() {
                        $fileInput.val('');
                        $attachBtn.removeClass('prompt-attachment-active');
                        $nameSpan.text('');
                    }
                    $attachBtn.on('click', function (e) {
                        e.preventDefault();
                        if ($fileInput.val())
                            return;
                        $attachBtn.addClass('prompt-attachment-active');
                        $fileInput.click();
                        $fileInput.one('cancel', function () {
                            $attachBtn.removeClass('prompt-attachment-active');
                        });
                    });
                    const MAX_FILE_SIZE = 10485760;
                    $fileInput.on('change', function () {
                        var _a;
                        const file = (_a = this.files) === null || _a === void 0 ? void 0 : _a[0];
                        if (file) {
                            const allowedExtensions = /(\.pdf|\.jpg|\.jpeg|\.png|\.heic|\.heif|\.webp|\.txt|\.csv)$/i;
                            if (file.size > MAX_FILE_SIZE) {
                                appn.toast.notify(appn.toast.Type.error, T("The selected file is too large. Please select a file smaller than 10MB."));
                                resetAttachment();
                                return;
                            }
                            if (!allowedExtensions.exec(file.name)) {
                                appn.toast.notify(appn.toast.Type.error, T("Invalid file type selected. Supported formats: PDF, Images (JPEG, PNG, WEBP, HEIC), TXT, and CSV."));
                                resetAttachment();
                                return;
                            }
                            $nameSpan.text(file.name);
                            $attachBtn.addClass('prompt-attachment-active');
                        }
                        else {
                            resetAttachment();
                        }
                    });
                    $removeBtn.on('click', function (e) {
                        e.stopPropagation();
                        resetAttachment();
                    });
                }
                function startAIGenerationSequence() {
                    var _a, _b;
                    const $loadingState = $('#ai-loading-state');
                    const $loadingText = $('#ai-loading-text');
                    const $generateBtn = $('#btn-generate-ai-form');
                    const $chipsContainer = $('#ai-prompt-chips');
                    const prompt = $('#ai-prompt-text').val();
                    const $fileInput = $('#prompt-attachment-input');
                    $loadingState.removeClass('d-none').addClass('d-flex');
                    $generateBtn.prop('disabled', true);
                    $chipsContainer.css({ 'opacity': '0.4', 'pointer-events': 'none' });
                    const messages = [
                        T("Analyzing your requirements..."),
                        T("Designing form structure..."),
                        T("Optimizing for your industry..."),
                        T("Finalizing your application...")
                    ];
                    let currentMsgIndex = 0;
                    let rotateTimer = null;
                    let isFinalized = false;
                    const resetLoadingState = () => {
                        clearTimeout(rotateTimer);
                        $loadingText.stop(true, true);
                        $loadingState.addClass('d-none');
                        $generateBtn.prop('disabled', false);
                        $chipsContainer.css({ 'opacity': '1', 'pointer-events': 'auto' });
                    };
                    const safeFinalize = () => {
                        if (isFinalized)
                            return;
                        isFinalized = true;
                        clearTimeout(rotateTimer);
                        $loadingText.stop(true, true);
                        finalizeGeneration();
                    };
                    const rotateMessages = () => {
                        if (currentMsgIndex >= messages.length - 1) {
                            $loadingText.text(messages[messages.length - 1]);
                            return;
                        }
                        currentMsgIndex++;
                        $loadingText.fadeOut(400, function () {
                            $(this).text(messages[currentMsgIndex]).fadeIn(400, () => {
                                rotateTimer = setTimeout(rotateMessages, 4000);
                            });
                        });
                    };
                    const finalizeGeneration = () => {
                        $loadingState.fadeOut(500, function () {
                            $(this).addClass('d-none');
                            $generateBtn.prop('disabled', false);
                            $chipsContainer.css({ 'opacity': '1', 'pointer-events': 'auto' });
                            const formName = $('.ai-chip.active').text().trim();
                            $('.generated-form-name').text(formName);
                            appn.localStorage.setItem('lastGeneratedFormName', formName);
                            updateStep1NextButton();
                            navigateToStep(2);
                        });
                    };
                    const formData = new FormData();
                    formData.append('userPrompt', prompt);
                    const file = (_b = (_a = $fileInput[0]) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
                    if (file)
                        formData.append('attachment', file);
                    $.ajax({
                        headers: appn.verifyHeader,
                        url: _initArgs.generateFormUrl,
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        dataType: 'json',
                        success: (result) => {
                            var _a;
                            const parsedData = typeof result === 'string' ? JSON.parse(result) : result;
                            if (!parsedData || parsedData.Failed || parsedData.Success === false || parsedData.Error) {
                                const errorMsg = ((_a = parsedData === null || parsedData === void 0 ? void 0 : parsedData.Error) === null || _a === void 0 ? void 0 : _a.message) || (parsedData === null || parsedData === void 0 ? void 0 : parsedData.Message) || T("Error generating form.");
                                appn.toast.notify(appn.toast.Type.error, errorMsg);
                                resetLoadingState();
                                return;
                            }
                            const generatedFormId = parsedData.Result;
                            appn.localStorage.setItem('lastGeneratedFormId', generatedFormId);
                            appn.localStorage.setItem('lastGeneratedPrompt', prompt);
                            safeFinalize();
                            appn.posthog.capture('form_generated', { introVersion: 'v2' });
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            if (jqXHR.responseText) {
                                try {
                                    const errorData = JSON.parse(jqXHR.responseText);
                                    if (errorData.Error)
                                        appn.toast.notify(appn.toast.Type.error, errorData.Error.title || T("Error generating form."));
                                }
                                catch (e) {
                                    appn.toast.notify(appn.toast.Type.error, T("Error generating form."));
                                }
                            }
                            else
                                appn.toast.notify(appn.toast.Type.error, T("Error generating form."));
                            resetLoadingState();
                        }
                    });
                    rotateTimer = setTimeout(rotateMessages, 4000);
                }
                function saveUsageAnalyticsConsent(isAllowed) {
                    const data = { allowTracking: isAllowed };
                    $.ajax({
                        headers: appn.verifyHeader,
                        url: _initArgs.saveConsentUrl,
                        data: data,
                        type: 'POST',
                        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                        dataType: 'json',
                        success: function () {
                            appn.requestUser.allowUsageAnalytics = isAllowed;
                            $('#usage-analytics-modal').fadeOut();
                            if (isAllowed)
                                appn.posthog.capture('introduction_viewed', { introStep: currentStep, introVersion: 'v2' });
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if (!errorThrown || textStatus === 'parsererror')
                                errorThrown = appn.strings.errorRetrievingData;
                            appn.toast.notify(appn.toast.Type.error, errorThrown);
                        }
                    });
                }
                function findCurrentStep() {
                    const introState = appn.localStorage.getItem(_introLocalStorageKey);
                    let startStep = 1;
                    if (appn.utils.hasValue(introState) && introState.currentStep)
                        startStep = normalizeStep(introState.currentStep);
                    if (!hasGeneratedForm() && startStep === 2)
                        startStep = 3;
                    navigateToStep(startStep);
                }
                index.findCurrentStep = findCurrentStep;
                function checkFirstVisitState() {
                    const introState = appn.localStorage.getItem(_introLocalStorageKey) || {};
                    const isMobile = $('.product-intro-container').hasClass('is-mobile');
                    if (!isMobile && !introState.hasSeenAccountCreated) {
                        introState.hasSeenAccountCreated = true;
                        appn.localStorage.setItem(_introLocalStorageKey, introState);
                    }
                }
            })(index = introduction.index || (introduction.index = {}));
        })(introduction = views.introduction || (views.introduction = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
